export function downloadUrlProxyfier(url) {
  if (url && process.env.REMOTE_DOWNLOAD_API_ENDPOINT) {
    let damFilePath = url.split("/uploads")[1]
    if (damFilePath) {
      return `${
        process.env.REMOTE_DOWNLOAD_API_ENDPOINT
      }?file=${encodeURIComponent(damFilePath)}`
    } else {
      return url
    }
  } else {
    return url
  }
}
